import { render, staticRenderFns } from "./HeadImage.vue?vue&type=template&id=60c7c0d1&scoped=true"
import script from "./HeadImage.vue?vue&type=script&lang=js"
export * from "./HeadImage.vue?vue&type=script&lang=js"
import style0 from "./HeadImage.vue?vue&type=style&index=0&id=60c7c0d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7c0d1",
  null
  
)

export default component.exports